import { ApiRequestOptions, localApiDelete, localApiFetch, localApiGet, localApiPatch, localApiPost, localApiPut } from '@websolutespa/bom-mixer-store';
import { useHttpFetch } from '../useHttp/useHttp';
import { useLayout } from '../useLayout/useLayout';

export function useApiFetch<T = unknown>(pathname: string, options: ApiRequestOptions = {}) {
  const layout = useLayout();
  // const layout = { locale: '', market: '' };
  return useHttpFetch<T>(pathname, options, localApiFetch, layout);
}

export function useApiGet<T = unknown>(pathname: string, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'GET' });
}

export function useApiPost<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'POST', body: payload ? JSON.stringify(payload) : undefined });
}

export function useApiPut<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'PUT', body: payload ? JSON.stringify(payload) : undefined });
}

export function useApiPatch<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'PATCH', body: payload ? JSON.stringify(payload) : undefined });
}

export function useApiDelete<T = unknown>(pathname: string, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'DELETE' });
}

type Api = {
  get: <T = unknown>(pathname: string, options?: ApiRequestOptions) => Promise<T>;
  post: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  put: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  patch: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  delete: <T = unknown>(pathname: string, options?: ApiRequestOptions) => Promise<T>;
};

export function useApi(): Api {
  const layout = useLayout();
  // const layout = { locale: '', market: '' };
  return {
    get: async <T = unknown>(pathname: string, options: ApiRequestOptions = {}) => {
      return localApiGet<T>(pathname, options, layout);
    },
    post: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localApiPost<T>(pathname, payload, options, layout);
    },
    put: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localApiPut<T>(pathname, payload, options, layout);
    },
    patch: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localApiPatch<T>(pathname, payload, options, layout);
    },
    delete: async <T = unknown>(pathname: string, options: ApiRequestOptions = {}) => {
      return localApiDelete<T>(pathname, options, layout);
    },
  };
}
